module.exports = __webpack_public_path__ + "static/media/vector-field.a871e22a.mp4";